import { FC, useEffect, useState } from "react"
import { getHistoricView, HistoricMedia, HistoricView } from "../../../api/channelsApi";
import { Guid } from "../../../api/baseApi";
import { getTags } from "../../../api/tagApi";
import { useParams } from "react-router-dom";
import { getPastDateByDaysAgo } from "../../../services/dateService";
import { FormInput, FormRow } from "../formRow/FormRow";
import FormCheckbox from "../formRow/FormCheckbox";
import { Button } from "../Button";
import Select, { MultiValue } from "react-select";
import { addLeadingZero, formatDuration, formatToPercent } from "../../../services/common";
import { MediaType } from "../../../api/mediaApi";
import SvgSelector from "../svgSelector/SvgSelector";

interface  ChannelPlaylistParams{
    channelId: Guid,
    nestedPlayListsId: Guid
}

type Option<T> = { value: T, label: string}

const HistoricViewBlock:FC = () => {
    let [selectedDate, setSelectedDate] = useState<string>(`${getPastDateByDaysAgo(0)}T00:00`)
    let [historicView, setHistoricView] = useState<HistoricView>()
    let [tags,setTags] = useState<Option<Guid>[]>([]);
    let [selectedTagIds, setSelectedTagIds] = useState<Guid[]>([]);

    let [isLiveToggle, setIsLiveToggle] = useState(false);

    let { channelId, nestedPlayListsId } = useParams<ChannelPlaylistParams>();

    useEffect(()=>{
        async function fetchData(){
            await Promise.all([updateTags()])
        }

        fetchData()
    },[])

    const updateHistoricView = async () => {
        let request = {
            dateTimeString: selectedDate,
            isLive: isLiveToggle,
            tagIds: selectedTagIds
        }

        let response = await getHistoricView(channelId, nestedPlayListsId, request);
        if( response.type === "succes") {
            setHistoricView(response.data.data)
        }
    }

    const updateTags = async () => {
        let tagResponse = await getTags();
        if(tagResponse.type == "succes") {
            setTags([
                {
                    label: "No Tags",
                    value: "00000000-0000-0000-0000-000000000000"
                },
                ...tagResponse.data.items.map( t => { return {label:t.name, value:t.id}})
            ])
        }
    }

    const onDateChanged = (date: string) => {
        setSelectedDate(date);
    }

    const onSelectedTag = async (newValue: MultiValue<Option<Guid>>) => {
        if(newValue){
            let newTagIds = newValue.map(el => el.value)
            setSelectedTagIds(newTagIds)
        } else {
            setSelectedTagIds([])
        }
    }

    const renderMediaTypePreview = (media: HistoricMedia) => {
        switch(media.mediaType){
            case MediaType.Image : return <img className="" src={media.url} alt="" />;
            case MediaType.Video : return <img className="" src={media.url} alt="" />;
            case MediaType.VastUrl : return <SvgSelector title="url" />;
            case MediaType.Youtube : return <img className="" src={media.url} alt="" />;
            case MediaType.YoutubeLive : return <img className="" src={media.url} alt="" />;
            case MediaType.WebPage : return <SvgSelector title="webview" />;
        }
    }

    const renderHistoricMedia = (media: HistoricMedia[]) => {
        return media.map( (m, i) => {
            return <tr key={i}>
                <td>{addLeadingZero(++i, 2)}</td>
                <td>{renderMediaTypePreview(m)}</td>
                <td><p style={{overflowWrap:"anywhere", width:150}}>{m.name}</p></td>
                <td>{formatDuration(m.durationMs)}</td>
            </tr>
        })
    }

    const renderHistoricView = (data: HistoricView) => {
        const [date, time] = data.forDateTime.split("T")
        return <div className="w-100">
            <h3>{date} / {time.split(".")[0]} {data.isHistorian ? <span>Historical</span> : null}</h3>

            <div className="media-live-statistic col-2">
                <div className="media-live-statistic__row">
                    <div className=""></div>
                    <div className=""></div>
                </div>
                <div className="media-live-statistic__row">
                    <div className=""><b>Campaigns</b></div>
                    <div className="">{formatDuration(data.statistic.campaignsDurationMs)} ({formatToPercent(data.statistic.campaignsPercentage)})</div>
                </div>
                <div className="media-live-statistic__row">
                    <div className=""><b>Network Content</b></div>
                    <div className="">{formatDuration(data.statistic.siteContentDurationMs)} ({formatToPercent(data.statistic.siteContentPercentage)})</div>
                </div>
                <div className="media-live-statistic__row">
                    <div className=""><b>Inhouse Content</b></div>
                    <div className="">{formatDuration(data.statistic.inhouseContentDurationMs)} ({formatToPercent(data.statistic.inhouseContentPercentage)})</div>
                </div>
                <div className="media-live-statistic__row">
                    <div className=""><b>Others</b></div>
                    <div className="">{formatDuration(data.statistic.othersDurationMs)} ({formatToPercent(data.statistic.othersPercentage)})</div>
                </div>
                <div className="media-live-statistic__row">
                    <div className=""><b>Total</b></div>
                    <div className="">{formatDuration(data.statistic.total)}</div>
                </div>
            </div>

            <div className="" style={{overflow: "auto", maxHeight:915, paddingRight:5}}>
                {data.media.length ? <table className="table modal-table media-list-table">
                    <thead>
                        <tr>
                            <td></td>
                            <td></td>
                            <td>Name</td>
                            <td>Duration</td>
                        </tr>
                    </thead>
                    <tbody>
                        {renderHistoricMedia(data.media)}
                    </tbody>
                </table> : <p>No Items</p>}
            </div>
        </div>
    }

    return (
        <>
            <div className="w-100">
                <FormRow>
                    <FormInput
                        errorMessage=""
                        id="date1"
                        isError={false}
                        type="datetime-local"
                        onChangeValue={(v) => {onDateChanged(v)}}
                        value={selectedDate}
                        title="Time"
                    />  
                </FormRow>
                <div className="d-flex gap15 align-items-center">
                    <FormRow>
                        <label>Tags Filter</label>
                        <Select 
                            className={`w-100`}
                            options={tags}
                            classNamePrefix={`select`}
                            onChange={onSelectedTag} 
                            isClearable={true}
                            isMulti={true}
                        />
                    </FormRow>

                    <div className="d-flex align-items-center" style={{flex:"0 0 auto", width:"120px"}}>
                        <FormCheckbox id={`playlist-checkbox-${Math.random()}`} checked={isLiveToggle} onChange={setIsLiveToggle} />
                        <span className="status-block">
                            {isLiveToggle ? <span className="current-status online">&nbsp;Live</span> : <span className="current-status offline">&nbsp;Scheduled</span>}
                        </span>
                    </div>

                    <Button color="green"  label="Update" onClick={updateHistoricView} />
                </div>
            </div>
            {historicView ? renderHistoricView(historicView) : <div style={{minHeight:"200px"}}></div>}
        </>
    )
}

export default HistoricViewBlock